import { AccordionList, Typography } from '@/primer/components';
import type { AccordionListItem } from '@/primer/components';
import { PageColumn } from '@/components/layout';

/**
 * Support page with FAQ accordion
 * Provides answers to common questions about the Influenster for Creators program
 */

const FAQ_ITEMS: AccordionListItem[] = [
  {
    title: 'What is Influenster for Creators?',
    content: (
      <Typography variant="body" size="small" color="bodylight">
        Influenster for Creators is a platform that connects content creators with brands for
        product sampling and collaboration opportunities. As a creator, you can receive free
        products to try and share your authentic experiences with your audience.
      </Typography>
    ),
  },
  {
    title: 'Why do I need to connect my Instagram account?',
    content: (
      <Typography variant="body" size="small" color="bodylight">
        Connecting your Instagram (Business or Creator account) is the only way for us to verify
        your amazing reach and engagement! It allows us to match you with the best free products and
        deals that fit your specific niche and audience demographics.
      </Typography>
    ),
  },
  {
    title: 'How long do I have to post once I receive a product?',
    content: (
      <Typography variant="body" size="small" color="bodylight">
        The posting deadline varies by campaign, but typically you'll have 14-30 days after
        receiving your product to complete your required tasks. You can always check the specific
        deadline in your campaign details page.
      </Typography>
    ),
  },
  {
    title: 'Can I see my program history?',
    content: (
      <Typography variant="body" size="small" color="bodylight">
        Yes! You can view all your past and current campaigns from your dashboard. This includes
        campaign status, completion rates, and any feedback from brands.
      </Typography>
    ),
  },
  {
    title: 'What if a product arrives damaged?',
    content: (
      <Typography variant="body" size="small" color="bodylight">
        If your product arrives damaged, please contact us immediately at{' '}
        <a href="mailto:creators@influenster.com" className="text-interactive hover:underline">
          creators@influenster.com
        </a>{' '}
        with photos of the damage. We'll work with the brand to resolve the issue and may be able to
        send a replacement.
      </Typography>
    ),
  },
  {
    title: 'Are these campaigns paid or just product-based?',
    content: (
      <Typography variant="body" size="small" color="bodylight">
        Most campaigns on Influenster for Creators are product-based, meaning you receive free
        products in exchange for creating content. However, some campaigns may include additional
        compensation. Campaign details will always clearly state what's included.
      </Typography>
    ),
  },
];

export function Support() {
  return (
    <PageColumn className="py-7 space-y-7">
      <div className="space-y-2">
        <Typography variant="sectionHeader" size="medium">
          FAQ&apos;S
        </Typography>
        <AccordionList items={FAQ_ITEMS} />
      </div>

      <div className="space-y-3">
        <Typography variant="header" size="h2">
          Still have questions?
        </Typography>
        <Typography variant="body" size="medium">
          If you can&apos;t find what you need, email us at{' '}
          <a href="mailto:creators@influenster.com" className="text-interactive hover:underline">
            creators@influenster.com
          </a>
          . We&apos;re here to help with your account or any of your collabs.
        </Typography>
      </div>
    </PageColumn>
  );
}

export default Support;
